<template>
  <div style="height: 1px;">
    <v-menu offset-y :close-on-click="true" :close-on-content-click="true">
      <template v-slot:activator="{ on }">
        <v-btn
          id="gondola-menu"
          style="z-index: 5000"
          absolute
          left
          color="black"
          dark
          fab
          v-on="on">
          <v-icon class="mdi mdi-gondola" />
          <p class="sr-only">Gondola</p>
        </v-btn>
      </template>
      <v-list>
        <v-list-item id="gondola-fill-form" @click="fillForm()">
          <v-list-item-title>Fill out form</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name:  'Gondola',
  computed: {
    ...mapGetters(['applyCard']),
  },
  methods: {
    setField(id, value) {
      const el = this.$root.$el.querySelector(id)
      if (el) {
        (el).value = value;
        (el).dispatchEvent(new Event('input'))
      }
    },
    clickField(id) {
      const el = this.$root.$el.querySelector(id)
      if (el) {
        (el).click()
      }
    },
    fillForm() {
      switch(this.applyCard) {
        case 'address-amount-card':
          this.populateAddressAmount()
          break
        case 'account-creation-card':
          this.populateAccountCreation()
          break
      }
    },
    populateAddressAmount() {
      this.setField('#dm-amount-input', this.$faker().finance.amount(1000, 10000, 0))
      this.setField('#dm-phone-input', this.$faker().phone.phoneNumber('###-###-####'))
      this.setField('#dm-apt-input', this.$faker().address.secondaryAddress())
      this.clickField('#dm-rent-btn')
    },
    populateAccountCreation() {
      this.setField('#dm-email-input', this.$faker().internet.email())
      this.setField('#dm-password-input', 'password')
    }
  }
};
</script>
